import {computed} from "vue";

import {createRouter, createWebHistory} from 'vue-router'

import store from '@/store/store'
import {ApiReport} from "@/api/api.report";
import {isPublicRoute} from "@/router/publicRoutes";

const prevUrl = computed(() => store.getters.getPrevUrl)

const router = createRouter({
  history: createWebHistory() ,  // createWebHashHistory 해시모드, createWebHistory 히스토리 모드
  linkActiveClass: "on",
  routes: [
    {
      path: '/testChild',
      name: "testChild",
      meta: { layout : "layoutFull", bodyclass: "black_body", title: "WECARE"},
      component: () => import('@/views/testChild')
    },
    {
      path: '/testParents',
      name: "testParents",
      meta: { layout : "layoutFull", bodyclass: "black_body", title: "WECARE"},
      component: () => import('@/views/testParents')
    },
    {
      // 로그인
      path: '/Login',
      name: "Login",
      meta: { layout : "layoutFull", bodyclass: "black_body", title: "WECARE"},
      component: () => import('@/views/LogIn')
    },
    {
      // 로그아웃
      path: '/LogOut',
      name: "LogOut",
      meta: { layout : "layoutFull", bodyclass: "black_body", title: "WECARE"},
      component: () => import('@/views/LogOut')
    },
    {
      // 회원가입 - step 1
      path: '/JoinStep01',
      name: "JoinStep01",
      meta: { layout : "layoutFull", bodyclass: "white_body", title: "WECARE"},
      component: () => import('@/views/JoinStep01')
    },
    {
      // 회원가입 - step 2
      path: '/JoinStep02',
      name: "JoinStep02",
      meta: { layout : "layoutFull", bodyclass: "white_body", title: "WECARE"},
      component: () => import('@/views/JoinStep02')
    },
    {
      // 회원가입 - step 3
      path: '/JoinStep03',
      name: "JoinStep03",
      meta: { layout : "layoutFull", bodyclass: "white_body", title: "WECARE"},
      component: () => import('@/views/JoinStep03')
    },
    {
      // 메인화면 - 의료진관리
      /* path: '/',
      alias : ['/DoctorMng','/'],
      name: "main", */
      path: "/DoctorMng",
      name: "DoctorMng",
      meta: { layout : "layoutContents", bodyclass: "", title: "WECARE"},
      component : () => import('@/views/DoctorMng'),
      beforeEnter: (to, from, next) => {
        const adminInfo = store.getters.getAdminInfo
        if (adminInfo.admAuth === 'SUPER_ADMIN' || adminInfo.admAuth === 'HOSP_ADMIN') {
          next();
        } else {
          next('/PatientMng');
        }
      },
    },
    {
      // 환자관리
      path: '/PatientMng',
      name: "PatientMng",
      meta: { layout : "layoutContents", bodyclass: "", title: "WECARE"},
      component : () => import('@/views/PatientMng')
    },
    {
      // 환자관리 - 외래 환자
      path: '/PatientMngToday',
      name: "PatientMngToday",
      meta: { layout : "layoutContents", bodyclass: "", title: "WECARE"},
      component : () => import('@/views/PatientMngToday')
    },
    {
      // 환자관리 상세
      path: '/PatientMngDetail',
      name: "PatientMngDetail",
      meta: { layout : "layoutContents", bodyclass: "", title: "WECARE"},
      component : () => import('@/views/PatientMngDetail')
    },
    {
      // 설문관리 - 개별 설문관리
      path: '/SurveyMng',
      name: "SurveyMng",
      meta: { layout : "layoutContents", bodyclass: "", title: "WECARE"},
      component : () => import('@/views/SurveyMng')
    },
    {
      // 설문관리 - 개별 설문관리 설문생성
      path: '/SurveyMngReg',
      name: "SurveyMngReg",
      meta: { layout : "layoutContents", bodyclass: "", title: "WECARE"},
      component : () => import('@/views/SurveyMngReg')
    },
    {
      // 설문관리 - 개별 설문관리 설문수정
      path: '/SurveyMngUpd',
      name: "SurveyMngUpd",
      meta: { layout : "layoutContents", bodyclass: "", title: "WECARE"},
      component : () => import('@/views/SurveyMngUpd')
    },
    {
      // 설문관리 - 개별 설문관리 환자목록
      path: '/SurveyMngPatientList',
      name: "SurveyMngPatientList",
      meta: { layout : "layoutContents", bodyclass: "", title: "WECARE"},
      component : () => import('@/views/SurveyMngPatientList')
    },
    {
      // 설문관리 - 개별 설문관리 미리보기
      path: '/SurveyPreview',
      name: "SurveyPreview",
      meta: { layout : "layoutFull", bodyclass: "", title: "WECARE"},
      component : () => import('@/views/SurveyPreview')
    },
    {
      // 실제 설문 수행
      path: '/SurveyReal',
      name: "SurveyReal",
      meta: { layout : "layoutFull", bodyclass: "", title: "WECARE"},
      component : () => import('@/views/SurveyReal')
    },
    {
      // 실제 설문 수행
      path: '/SurveyRealGroup',
      name: "SurveyRealGroup",
      meta: { layout : "layoutFull", bodyclass: "", title: "WECARE"},
      component : () => import('@/views/SurveyRealGroup')
    },
    {
      // 실제 설문 수행
      path: '/SurveyRealResearch',
      name: "SurveyRealResearch",
      meta: { layout : "layoutFull", bodyclass: "", title: "WECARE"},
      component : () => import('@/views/SurveyRealResearch')
    },
    {
      // 실제 설문 수행
      path: '/SurveyRealFinal',
      name: "SurveyRealFinal",
      meta: { layout : "layoutFull", bodyclass: "", title: "WECARE"},
      component : () => import('@/views/SurveyRealFinal')
    },
    {
      // 설문관리 - 연구 설문관리
      path: '/SurveyMngRes',
      name: "SurveyMngRes",
      meta: { layout : "layoutContents", bodyclass: "", title: "WECARE"},
      component : () => import('@/views/SurveyMngRes')
    },
    {
      // 설문관리 - 그룹 설문관리
      path: '/SurveyMngGrp',
      name: "SurveyMngGrp",
      meta: { layout : "layoutContents", bodyclass: "", title: "WECARE"},
      component : () => import('@/views/SurveyMngGrp')
    },
    {
      // 설문관리 - 그룹 설문관리 환자목록
      path: '/SurveyMngGrpPatientList',
      name: "SurveyMngGrpPatientList",
      meta: { layout : "layoutContents", bodyclass: "", title: "WECARE"},
      component : () => import('@/views/SurveyMngGrpPatientList')
    },
    {
      // 설문 결과
      path: '/SurveyResult',
      name: "SurveyResult",
      meta: { layout : "layoutContents", bodyclass: "", title: "WECARE"},
      component : () => import('@/views/SurveyResult')
    },
    {
      // 설문 결과 보기 개별
      path: '/SurveyResultSingle',
      name: "SurveyResultSingle",
      meta: { layout : "layoutFull", bodyclass: "", title: "WECARE"},
      component : () => import('@/views/SurveyResultSingle')
    },
    {
      // KOQUSS 결과 보기 개별
      path: '/SurveyKoqussResult',
      name: "SurveyKoqussResult",
      meta: { layout : "layoutFull", bodyclass: "", title: "WECARE"},
      component : () => import('@/views/SurveyKoqussResult')
    },
    {
      // 설문 결과 보기 그룹
      path: '/SurveyResultGroup',
      name: "SurveyResultGroup",
      meta: { layout : "layoutFull", bodyclass: "", title: "WECARE"},
      component : () => import('@/views/SurveyResultGroup')
    },
    {
      // 문의게시판
      path: '/QnABoard',
      name: "QnABoard",
      meta: { layout : "layoutContents", bodyclass: "", title: "WECARE"},
      component : () => import('@/views/QnABoard')
    },
    {
      // 콘텐츠관리
      path: '/ContentsMng',
      name: "ContentsMng",
      meta: { layout : "layoutContents", bodyclass: "", title: "WECARE"},
      component : () => import('@/views/ContentsMng')
    },
    {
      // 콘텐츠관리 - 등록
      path: '/ContentsMngReg',
      name: "ContentsMngReg",
      meta: { layout : "layoutContents", bodyclass: "", title: "WECARE"},
      component : () => import('@/views/ContentsMngReg')
    },
    {
      // 콘텐츠프리셋관리 - 등록
      path: '/ContentsPresetMngReg',
      name: "ContentsPresetMngReg",
      meta: { layout : "layoutContents", bodyclass: "", title: "WECARE"},
      component : () => import('@/views/ContentsPresetMngReg')
    },
    {
      // 콘텐츠프리셋관리
      path: '/ContentsPresetMng',
      name: "ContentsPresetMng",
      meta: { layout : "layoutContents", bodyclass: "", title: "WECARE"},
      component : () => import('@/views/ContentsPresetMng')
    },
    {
      // FAQ관리
      path: '/FAQMng',
      name: "FAQMng",
      meta: { layout : "layoutContents", bodyclass: "", title: "WECARE"},
      component : () => import('@/views/FAQMng')
    },
    {
      // FAQ관리 등록
      path: '/FAQMngReg',
      name: "FAQMngReg",
      meta: { layout : "layoutContents", bodyclass: "", title: "WECARE"},
      component : () => import('@/views/FAQMngReg')
    },
    {
      // 쇼핑도움서비스
      path: '/ShoppingHelpService',
      name: "ShoppingHelpService",
      meta: { layout : "layoutContents", bodyclass: "", title: "WECARE"},
      component : () => import('@/views/ShoppingHelpService')
    },
    {
      // 내정보관리
      path: '/MyInfoMng',
      name: "MyInfoMng",
      meta: { layout : "layoutContents", bodyclass: "", title: "WECARE"},
      component : () => import('@/views/MyInfoMng')
    },
    {
      // KOQUSS-40 CSV 출력
      path: '/getKoquss40Report',
      name: "getKoquss40Report",
      beforeEnter(to, from, next) {
        let params = {}
        ApiReport.getKoquss40Report(params).then(res => {
            next(false);
        })
      },
      component: null, // 이 경로는 컴포넌트를 렌더링하지 않습니다.
    },
    {
      // KOQUSS-33 CSV 출력
      path: '/getKoquss33Report',
      name: "getKoquss33Report",
      beforeEnter(to, from, next) {
        let params = {}
        ApiReport.getKoquss33Report(params).then(res => {
          next(false);
        })
      },
      component: null, // 이 경로는 컴포넌트를 렌더링하지 않습니다.
    },
    {
      // 식이 및 NRS2002+환자증상 CSV 출력
      path: '/getNRS2002Report',
      name: "getNRS2002Report",
      beforeEnter(to, from, next) {
        let params = {}
        ApiReport.getNRS2002Report(params).then(res => {
          next(false);
        })
      },
      component: null, // 이 경로는 컴포넌트를 렌더링하지 않습니다.
    },
    {
      // EORTC QLQ-STO22 CSV 출력
      path: '/getSTO22Report',
      name: "getSTO22Report",
      beforeEnter(to, from, next) {
        let params = {}
        ApiReport.getSTO22Report(params).then(res => {
          next(false);
        })
      },
      component: null, // 이 경로는 컴포넌트를 렌더링하지 않습니다.
    },
    {
      // C30 CSV 출력
      path: '/getC30Report',
      name: "getC30Report",
      beforeEnter(to, from, next) {
        let params = {}
        ApiReport.getC30Report(params).then(res => {
          next(false);
        })
      },
      component: null, // 이 경로는 컴포넌트를 렌더링하지 않습니다.
    },
    {
      // 신체활동설문(PAQ) CSV 출력
      path: '/getPAQReport',
      name: "getPAQReport",
      beforeEnter(to, from, next) {
        let params = {}
        ApiReport.getPAQReport(params).then(res => {
          next(false);
        })
      },
      component: null, // 이 경로는 컴포넌트를 렌더링하지 않습니다.
    },
    {
      // 자기효능감 출력
      path: '/getSelfEfficacyReport',
      name: "getSelfEfficacyReport",
      beforeEnter(to, from, next) {
        let params = {}
        ApiReport.getSelfEfficacyReport(params).then(res => {
          next(false);
        })
      },
      component: null, // 이 경로는 컴포넌트를 렌더링하지 않습니다.
    },
    {
      // 유럽삶의질(EQ-5D-5L)설문 출력
      path: '/getEQ5D5LReport',
      name: "getEQ5D5LReport",
      beforeEnter(to, from, next) {
        let params = {}
        ApiReport.getEQ5D5LReport(params).then(res => {
          next(false);
        })
      },
      component: null, // 이 경로는 컴포넌트를 렌더링하지 않습니다.
    },
    {
      // 위케어만족도(CSAT)설문 출력
      path: '/getCSATReport',
      name: "getCSATReport",
      beforeEnter(to, from, next) {
        let params = {}
        ApiReport.getCSATReport(params).then(res => {
          next(false);
        })
      },
      component: null, // 이 경로는 컴포넌트를 렌더링하지 않습니다.
    },
    {
      // 데이터 조회 설문 출력
      path: '/getViewDataPreviewReport',
      name: "getViewDataPreviewReport",
      beforeEnter(to, from, next) {
        let params = {}
        ApiReport.getViewDataPreviewReport(params).then(res => {
          next(false);
        })
      },
      component: null, // 이 경로는 컴포넌트를 렌더링하지 않습니다.
    },
    {
      // 404 에러 페이지
      path : '/ErrorPage404',
      name : 'ErrorPage404',
      meta: { layout : "layoutFull", bodyclass: "white_body", title: "WECARE"},
      component:() => import('@/views/ErrorPage404.vue')
    },
    {
      // 401 에러 페이지
      path : '/ErrorPage401',
      name : 'ErrorPage401',
      meta: { layout : "layoutFull", bodyclass: "white_body", title: "WECARE"},
      component:() => import('@/views/ErrorPage401.vue')
    },
    {
      // 지정하지 않은 path 입력했을 경우 404로 이동
      path : '/:catchAll(.*)', // 모든 매치하지 않은 path
      redirect : '/ErrorPage404'
    },
    {
      // 게시판
      path: "/BoardMng",
      name: "BoardMng",
      meta: {layout: "layoutContents", bodyclass: "", title: "WECARE"},
      component:() => import('@/views/BoardMng.vue')
    },
    {
      // 연구회 소개
      path: "/ResearchIntro",
      name: "ResearchIntro",
      meta: {layout: "layoutContents", bodyclass: "", title: "WECARE"},
      component:() => import('@/views/ResearchIntro.vue')
    },
    {
      // 게시판 등록
      path: "/BoardMngReg",
      name: "BoardMngReg",
      meta: {layout: "layoutContents", bodyclass: "", title: "WECARE"},
      component:() => import('@/views/BoardMngReg.vue')
    },
    {
      // 게시글 상세보기
      path: "/BoardDetail",
      name: "BoardDetail",
      meta: {layout: "layoutContents", bodyclass: "", title: "WECARE"},
      component:() => import('@/views/BoardDetail.vue')
    },
    {
      // 연구 관리
      path: "/ResearchMng",
      name: "ResearchMng",
      meta: {layout: "layoutContents", bodyclass: "", title: "WECARE"},
      component:() => import("@/views/ResearchMng.vue")
    },
    {
      // 알림 관리 - 발송 규칙 목록
      path: "/NotificationRules",
      name: "NotificationRules",
      meta: {layout: "layoutContents", bodyclass: "", title: "WECARE"},
      component:() => import("@/views/NotificationRules.vue")
    },
    {
      // 알림 관리 - 발송 상태 목록
      path: "/NotificationStatus",
      name: "NotificationStatus",
      meta : {layout: "layoutContents", bodyclass: "", title: "WECARE"},
      component:() => import("@/views/NotificationStatus.vue")
    },
    {
      // 알림 관리 - 메시지 목록
      path: "/NotificationMessages",
      name : 'NotificationMessages',
      meta : {layout: "layoutContents", bodyclass: "", title: "WECARE"},
      component:() => import("@/views/NotificationMessages.vue")
    },
    {
      // 알림 관리 - 실시간 발송
      path: "/NotificationRealTime",
      name : 'NotificationRealTime',
      meta : {layout: "layoutContents", bodyclass: "", title: "WECARE"},
      component:() => import("@/views/NotificationRealTime.vue")
    },
    {
      // 데이터 조회
      path: "/ViewData",
      name: "ViewData",
      meta: {layout: "layoutContents", bodyclass: "", title: "WECARE"},
      component:() => import("@/views/ViewData.vue")
    },
    {
      // 대시보드
      path: "/",
      alias: ["/Dashboard", "/"],
      name: "main",
      meta: {layout: "layoutContents", bodyclass: "", title: "WECARE"},
      component:() => import("@/views/DashboardMain.vue")
    }
    ]
})

const isLoggedIn = () => {

  return (localStorage.getItem('_lunit_token') === null) ? false : true
}

// 라우터 이동 전 로그인 체크해서 Login 페이지로 이동
router.beforeEach((to, from, next) => {
  // 모바일 메뉴 닫는다. store 설정 변경..
  //store.commit("setIsMobileMenu", false)

  if (to.meta.bodyclass) {
    document.body.className = to.meta.bodyclass;
  } else {
    document.body.className = '';
  }

  // 로그인 처리.. 로그인 확인..
  const isPublic = isPublicRoute(to)

  if (!isPublic) {
    if (!isLoggedIn()) {

      return next({
        name: 'Login',
        query: { redirect: to.fullPath }   // ← 원래 가려던 경로를 redirect로 넘김
      })
    } else {

      // 약관 재동의 페이지에서 url 직접 입력으로 다른 페이지 넘어 갈 때 막기
      if(prevUrl.value === 'JoinStep01'){
        localStorage.removeItem("_lunit_token")
        store.commit('setAdminInfo', {})
        return next({
          path: '/Login'
        })
      }
    }
  } else {
    return next()
  }

  next();
})

// 라우터 이동후
router.afterEach((to) => {
  //store.commit('setPrevUrl', window.location.hash)
  let title = to.meta.title === undefined ? "WECARE" : to.meta.title
  document.title = title
})

export default router
